export default "/images/wind.svg?d2a4a1fe8ac82ef136c5d7163b075554";